import React from 'react';
import { Flags } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { COUNTRY_MAPPING } from './constants';
export const getListItem = (item) => {
    const { code, name } = item;
    const countryCode = code.toLowerCase();
    const iconType = Flags[COUNTRY_MAPPING[countryCode]];
    return {
        value: countryCode,
        label: name,
        icon: (React.createElement(SVGIcon, { type: iconType, uniquifyIDs: true })),
    };
};
export function isFooterBottomMenuEmpty(props) {
    return !props?.copyrightNotice || props.copyrightNotice.trim().length < 1;
}
